<template>
  <div class="content-wrapper">
    <v-select
      id="variant-list"
      v-model="variantSelected"
      :items="variants"
      :item-text="variant => variant.name"
      :item-value="variant => variant"
      attach
      dark
      outlined
      dense
      class="variant-select"
      @change="onVariantSelection"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import { Variant } from 'ctp-toll-domain';

const emit = defineEmits(['variantSelection']);
const props = defineProps({
  variants: {
    type: Array as PropType<Variant[]>,
    required: true
  }
});

const variants = computed(() => props.variants);

const variantSelected = computed(() => props.variants[0]);

function onVariantSelection(event: Event) {
  emit('variantSelection', event);
}
</script>
<style lang="scss" scoped>
@import './styles/variant-selector.scss';
</style>
